import { doRequest, applyFilters } from "./helpers";

const TwilioPhoneNumberService = {
  getTable: filters => {
    let path = "/twilio_phone_number/";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  },
  assignAgents: (twilioPhoneNumberIds, userIds) => {
    return doRequest("PUT", "/twilio_phone_number/assign_agents", {
      data: {
        twilio_phone_number_ids: twilioPhoneNumberIds,
        user_ids: userIds,
      },
    });
  },
  assignVoicemail: (twilioPhoneNumberId, voicemailId) => {
    return doRequest("PUT", "/twilio_phone_number/assign_voicemail", {
      data: {
        twilio_phone_number_id: twilioPhoneNumberId,
        voicemail_id: voicemailId,
      },
    });
  },
  assignHoldMessage: (twilioPhoneNumberId, holdMessage) => {
    return doRequest("PUT", "/twilio_phone_number/assign_hold_message", {
      data: {
        twilio_phone_number_id: twilioPhoneNumberId,
        ...holdMessage,
      },
    });
  },
  getHoldMessageLanguages: () => {
    return doRequest("GET", "/twilio_phone_number/hold_message_languages");
  },
  previewHoldMessage: holdMessage => {
    return doRequest("POST", "/twilio_phone_number/hold_message_preview", {
      data: holdMessage,
    });
  },
  getTwilioNumbersForFilters: filters => {
    let path = "/twilio_phone_number/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  },
};

export default TwilioPhoneNumberService;
